import React, { useCallback } from 'react';
import { Col, Row } from 'react-bootstrap';
import { CheckedOutSummary } from './CheckedOutSummary';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { Reporting } from '../common/Reporting';
import { ActionButton } from '../common/ActionButton';
import { SiteStyle } from '../common/SiteStyle';
import { Logo } from '../common/Logo';
import { Spacer } from '../common/Spacer';
import { useReportState } from '../../state/state';

export const CheckedOut = () => {
    const history = useHistory();
    const { token } = useParams<Token>();
    const { reportSuccess } = useReportState();

    const onClick = useCallback(() => {
        reportSuccess('');
        history.replace(`/welcome/${token}`);
    }, [reportSuccess]);

    return (
        <>
            <SiteStyle/>
            <Reporting/>
            <Spacer height="2em"/>
            <Row className="text-center summary-block">
                <Col>
                    <div className="heading">
                        Check Out Successful
                    </div>
                    <div className="sub-heading">
                        Thank you for visiting and have<br/> a safe onward journey.
                    </div>
                </Col>
            </Row>
            <Spacer height="2em"/>
            <CheckedOutSummary/>
            <ActionButton text="Close" onClick={onClick}/>
            <Spacer height="4em"/>
            <Logo/>
        </>
    );
}
